module.exports = __webpack_public_path__ + "static/media/mobimage6.16873f75.jpeg";